(function () {
  'use strict';

  angular.module('ringbaPortal').component('selectEventCallBack', {
    bindings: {
      campaign: '<',
      onUpdate: '&'
    },
    controller: SelectEventCallBackController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-event-callbacks/select-event-callback.view.html'
  });

  function SelectEventCallBackController(
    _,
    $anchorScroll,
    $scope,
    $uibModal,
    $location,
    $filter,
    accountsService,
    campaignServiceNew,
    callbackService,
    isMobileDevice,
    toaster,
    utils
  ) {

    'ngInject';

    const vm = this;
    const panelId = 'panel-event-event-callback';

    vm.currentEventCallBackBase = '';

    vm.eventCallBackToRemove = null;
    vm.modal = null;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.hasWebhooks = campaignServiceNew.hasWebhooks;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.unlinkFromCampaign = unlinkFromCampaign;
    vm.activateEventCallbackActions = activateEventCallbackActions;
    vm.confirmEventCallBackRemovalModal = confirmEventCallBackRemovalModal;
    vm.cancelModal = cancelModal;

    function onInit() {
      vm.isMobileView = isMobileDevice;
    }

    function onChanges(changesObj) {
      if (changesObj.campaign) {
        _loadEventCallBacks();
      }
    }

    function showForm(eventCallBack) {
      if (!vm.formActive) {
        if (eventCallBack) {
          eventCallBack.showEditForm = true;
        } else {
          vm.showAddNewForm = true;
        }
        vm.activeActionEventCallbackId = false;
        vm.formActive = true;
      }
    }

    function hideForm(event, eventCallBack) {
      if (eventCallBack) {
        eventCallBack.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
      _scrollToPixelsPanel();
    }

    function unlinkFromCampaign(eventCallBack) {
      if (!vm.formActive) {
        return campaignServiceNew
          .unLink(
            accountsService.currentAccountId,
            vm.campaign.id,
            eventCallBack.id,
            'eventCallBacks'
          )
          .then(function () {
            vm.onUpdate();
            _loadEventCallBacks();
            toaster.pop('success', $filter('translate')('PIXEL_REMOVE_SUCCESS'));
            vm.cancelModal();
          })
          .catch(utils.errorHandler);
      }
    }

    function activateEventCallbackActions(eventCallBackId) {
      if (!vm.formActive) {
        vm.activeActionEventCallbackId = vm.activeActionEventCallbackId == eventCallBackId ? false : eventCallBackId;
      }
    }

    function _loadEventCallBacks() {
      callbackService.getEventCallBacks(accountsService.currentAccountId)
        .then(function (response) {
          vm.eventCallBacks = response.data.eventCallBacks;
          _filterEventCallBacks();
        })
        .catch(utils.errorHandler);
    }

    function _filterEventCallBacks() {
      if (vm.eventCallBacks && vm.campaign) {
        vm.eventCallBacks = vm.eventCallBacks.filter(function (eventCallBack) {
          return !_.find(vm.campaign.eventCallBacks, {
            id: eventCallBack.id
          });
        });
      }
    }

    function _scrollToPixelsPanel() {
      $location.hash(panelId);
      $anchorScroll();
    }

    function confirmEventCallBackRemovalModal(eventCallBack) {
      if (!vm.formActive) {
        vm.eventCallBackToRemove = eventCallBack;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/select-event-callbacks/remove-event-callback.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.eventCallBackToRemove = null;
      }
    }

  }
})();
